import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import generateColors from '@/utils/color';
import { BlindWatermark, Watermark } from 'watermark-js-plus';
import { watch } from 'vue';
export default {
  components: {
    ElConfigProvider
  },
  setup() {
    const localColor = localStorage.getItem('color') || 'rgb(19,96,244)';

    // const  detectDeviceType = () => {
    //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    //   // 检查是否为移动设备
    //   if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
    //       return true;
    //   } else {
    //       return false;
    //   }
    // }
    // const isMobileDevice = detectDeviceType();
    // // 根据设备类型设置页面标题
    // document.title = isMobileDevice ? '中航人力助手' : '航融管家';
    const changePrimaryColor = value => {
      const domStyle = document.documentElement.style;
      let colorMap = generateColors(value);
      domStyle.setProperty('--el-color-primary', value);
      //生成不同1-9的透明度
      Object.keys(colorMap).forEach(key => {
        document.documentElement.style.setProperty(`--el-color-primary-${key}`, colorMap[key]);
      });
      localStorage.setItem('color', value);
    };
    // 监听用户信息变化，添加个性化水印

    watch(() => '', () => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const watermark = new BlindWatermark({
        // const watermark = new Watermark({
        content: `admin_id：${userInfo?.admin_id}  name:${userInfo?.name}`,
        // 1. 加密间距：减小水印单元尺寸，增加网格密度
        width: 200,
        // 宽度减小
        height: 20,
        // 高度减小
        gridLayoutOptions: {
          rows: 10,
          // 行数增加
          cols: 10,
          // 列数增加
          gap: [1, 1],
          // 间距减小
          backgroundImage: '#fff'
        },
        // 2. 加深颜色：降低透明度，使用深色字体
        fontSize: '18px',
        fontColor: '#000000',
        // 保持黑色，已经很深
        globalAlpha: 0.6,
        // 透明度降低，水印更明显
        rotate: 0,
        mode: 'blind',
        monitorProtection: true,
        onSuccess: () => {
          console.log('全局盲水印设置成功');
        }
      });
      watermark.create();
    }, {
      immediate: true
    });
    changePrimaryColor(localColor);
    return {
      zhCn
    };
  }
};